import { render, staticRenderFns } from "./DropdownHeader.vue?vue&type=template&id=3b4e6b2c&scoped=true&"
import script from "./DropdownHeader.vue?vue&type=script&lang=js&"
export * from "./DropdownHeader.vue?vue&type=script&lang=js&"
import style0 from "./DropdownHeader.vue?vue&type=style&index=0&id=3b4e6b2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4e6b2c",
  null
  
)

export default component.exports